export default {
  OK: 0,
  BEXT_OK: 1,
  ADAPTER_OK: 2
};
